import React from "react";
import ProductsPage from "./ProductsPage";
import V2RouteShell from "../V2RouteShell";

function ProductsV2(props) {
  return (
    <V2RouteShell>
      <ProductsPage {...props} />
    </V2RouteShell>
  );
}

export default ProductsV2;
